/* Brooks England — Wishlist card labels (Size / Color / Total)
 *
 * Swym's Storefront Layout renders each saved product as:
 *   .swym-storefront-layout-grid-item-price-variant
 *     .swym-storefront-layout-grid-item-final-price   ("$220.00")
 *     .swym-storefront-layout-price-devider           ("|")
 *     .swym-storefront-layout-grid-item-variants-container
 *       .swym-storefront-layout-variant               ("12l")
 *
 * The Brooks catalogue models products as single-variant, where the
 * only option ("SAP Size") carries the size and the COLOUR lives in a
 * product metafield (each colour is a separate product). So the colour
 * cannot be derived from the DOM/variant string — we fetch it from a
 * tiny alternate template: /products/{handle}?view=swym-meta.
 *
 * The result is reshaped into labelled rows that match the Figma:
 *   Size:  12 L
 *   Color: Grey
 *   Total: $220.00
 */

(function () {
  'use strict';

  var metaCache = {};

  /* Fetch { color, size } from the alternate product template. */
  function getMeta(href) {
    var url;
    try {
      url = new URL(href, window.location.origin);
    } catch (e) {
      return Promise.resolve({});
    }
    var variantId = url.searchParams.get('variant');
    url.search = '';
    url.searchParams.set('view', 'swym-meta');
    if (variantId) url.searchParams.set('variant', variantId);

    var key = url.toString();
    if (metaCache[key]) return metaCache[key];

    metaCache[key] = fetch(key, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) {
        try { return JSON.parse(t.trim()); } catch (e) { return {}; }
      })
      .catch(function () { return {}; });
    return metaCache[key];
  }

  /* "12l" -> "12 L"; leave everything else untouched. */
  function prettySize(size) {
    if (!size) return '';
    var m = size.match(/^(\d+)\s*l$/i);
    return m ? m[1] + ' L' : size;
  }

  function makeRow(label, value, extraClass) {
    var row = document.createElement('div');
    row.className = 'be-wl-row' + (extraClass ? ' ' + extraClass : '');
    var l = document.createElement('span');
    l.className = 'be-wl-label';
    l.textContent = label + ':';
    var v = document.createElement('span');
    v.className = 'be-wl-value';
    v.textContent = value;
    row.appendChild(l);
    row.appendChild(v);
    return row;
  }

  function enhanceItem(item) {
    if (item.dataset.beWlDone) return;

    var pv = item.querySelector('.swym-storefront-layout-grid-item-price-variant');
    if (!pv) return;
    item.dataset.beWlDone = '1';

    var titleEl = item.querySelector('.swym-storefront-layout-grid-item-title');
    var href = titleEl ? titleEl.getAttribute('href') : null;

    var variantEl = pv.querySelector('.swym-storefront-layout-variant');
    var divider = pv.querySelector('.swym-storefront-layout-price-devider');
    var variantWrap = pv.querySelector('.swym-storefront-layout-grid-item-variants-container');
    var priceEl = pv.querySelector('.swym-storefront-layout-grid-item-final-price');

    var domSize = variantEl ? variantEl.textContent.trim() : '';

    /* Hide Swym's native inline variant + divider — we rebuild the rows. */
    if (divider) divider.style.display = 'none';
    if (variantWrap) variantWrap.style.display = 'none';

    /* Options container (Size / Color) goes above the Total row. */
    var opts = document.createElement('div');
    opts.className = 'be-wl-options';

    /* Total row: reuse the existing price node so currency/market stays intact. */
    if (priceEl && !priceEl.closest('.be-wl-total-row')) {
      var totalRow = document.createElement('div');
      totalRow.className = 'be-wl-row be-wl-total-row';
      var totalLabel = document.createElement('span');
      totalLabel.className = 'be-wl-label';
      totalLabel.textContent = 'Total:';
      priceEl.classList.add('be-wl-value');
      pv.insertBefore(totalRow, priceEl);
      totalRow.appendChild(totalLabel);
      totalRow.appendChild(priceEl);
    }

    /* Options container first, so the visual order is Size, Color, Total. */
    pv.insertBefore(opts, pv.firstChild);

    var render = function (meta) {
      meta = meta || {};
      var size = prettySize(domSize || meta.size || '');
      var color = (meta.color || '').trim();

      opts.innerHTML = '';
      /* Skip Size for one-size products (Swym variant "Tu" / "Default Title"). */
      var sizeHidden = !size || /^(default title|tu)$/i.test(size);
      if (!sizeHidden) {
        opts.appendChild(makeRow('Size', size));
      }
      if (color) {
        opts.appendChild(makeRow('Color', color));
      }
    };

    if (href) {
      getMeta(href).then(render);
    } else {
      render({});
    }
  }

  function enhanceAll() {
    var items = document.querySelectorAll(
      '#swym-storefront-layout-items-container .swym-storefront-layout-grid-item:not([data-be-wl-done])'
    );
    for (var i = 0; i < items.length; i++) {
      enhanceItem(items[i]);
    }
  }

  /* Run now and again whenever Swym re-renders the list. */
  var observer = new MutationObserver(enhanceAll);
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAll);
  } else {
    enhanceAll();
  }
})();
